import React from "react";
import VerifyEmailModel from "./VerifyEmailModel";

function VarifyEmailBtn({ updatetype, verifystatus, value }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  

  return (
    <>
      <span
        className=" emailverifytitle verifynow mx-2 text-danger"
        onClick={handleOpen}
      >
        {verifystatus === "1" ? " Verify Now " : " Update Now "}
      </span>
      <VerifyEmailModel
        open={open}
        handleClose={handleClose}
        updatetype={updatetype}
        verifystatus={verifystatus}
        value={value}
      />
    </>
  );
}

export default VarifyEmailBtn;
